import { boolean, object } from 'yup';

export const joinInvitationTournamentValidationSchema = () => {
  return object().shape({
    isRewardBalanceSelected: boolean().optional(),
  });
};
